export default __webpack_public_path__ + "static/media/boat-logo.d7bf7ba8.svg";